import { SecurityRequirementElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class SecurityRequirement extends SecurityRequirementElement {}
export default SecurityRequirement;